import { render, staticRenderFns } from "./ChooseOrder.vue?vue&type=template&id=2bad1f16"
import script from "./ChooseOrder.vue?vue&type=script&lang=js"
export * from "./ChooseOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports